import {ObjectIndex} from '../../types/common/index/ObjectIndex';
import {asObjectOrNull} from './asObjectOrNull';

export function asObject(o?: unknown): Record<ObjectIndex, unknown> {
    return asObjectOrNull(o) ?? {};
}
